import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { buildExcelData } from 'utils/excel/buildExcelData';
import { ExcelExportConfig } from 'utils/excel/excelTypes';

export const useExportExcel = <T,>() => {
  const exportToExcel = (
    data: T[],
    config: ExcelExportConfig<T>
  ) => {
    if (!data || !data.length) return;

    const excelData = buildExcelData(data, config.columns);

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    worksheet['!cols'] = Object.keys(excelData[0]).map(() => ({
      wch: 22,
    }));

    const workbook = {
      Sheets: {
        [config.sheetName || 'Sheet1']: worksheet,
      },
      SheetNames: [config.sheetName || 'Sheet1'],
    };

    const buffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    const blob = new Blob([buffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    saveAs(blob, `${config.fileName}.xlsx`);
  };

  return { exportToExcel };
};
